import list from 'modules/botFlow/list/botFlowListReducers';
import form from 'modules/botFlow/form/botFlowFormReducers';
import view from 'modules/botFlow/view/botFlowViewReducers';
import destroy from 'modules/botFlow/destroy/botFlowDestroyReducers';
import importerReducer from 'modules/botFlow/importer/botFlowImporterReducers';
import { combineReducers } from 'redux';

export default combineReducers({
  list,
  form,
  view,
  destroy,
  importer: importerReducer,
});
